import axios from "axios";
import type { TesteModuloRegistro } from "@/types/teste-modulo";

// Mesma API do histórico de impressão (apiv1_impressaoinovacode, porta 5001).
const teste_modulo_api = axios.create({
  baseURL: import.meta.env.VITE_HISTORICO_API || "http://localhost:5001/",
});

// Salva uma sessão de testes. O backend recalcula os totais e o resultado geral.
export async function salvarTesteModulo(
  registro: Omit<
    TesteModuloRegistro,
    | "_id"
    | "createdAt"
    | "updatedAt"
    | "resultado_geral"
    | "total_testes"
    | "total_pass"
    | "total_fail"
    | "total_skip"
  >,
): Promise<TesteModuloRegistro> {
  const { data } = await teste_modulo_api.post<TesteModuloRegistro>(
    "/v1/teste-modulo",
    registro,
  );
  return data;
}

// Histórico de testes de um módulo (mais recente primeiro).
export async function buscarHistoricoTestes(
  hardwareId: string,
  limite = 100,
): Promise<TesteModuloRegistro[]> {
  const { data } = await teste_modulo_api.get<TesteModuloRegistro[]>(
    `/v1/teste-modulo/${encodeURIComponent(hardwareId)}?limit=${limite}`,
  );
  return data;
}

export default teste_modulo_api;
